import React, { Fragment, useState, useRef } from 'react';
import GAButton from 'components/GAButton';
import api from 'constants/api';
import axios from 'helpers/axios';
import LuxityLoader from 'components/LuxityLoader';
import checkMinimumPaymentAmount from 'functions/checkMinimumPaymentAmount';

export default function Index({
  sale_id,
  sale_outstanding_amount,
  sale_total_amount,
}) {
  const [paymentAmount, setPaymentAmount] = useState();
  const [validationMsg, setValidationMsg] = useState();
  const inputAmountRef = useRef();
  const [errExists, setErrExists] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleValidation = () => {
    if (inputAmountRef.current.validity.badInput) {
      setErrExists(true);
      setValidationMsg(`This field only accepts numbers`);
      return false;
    }
    if (!paymentAmount || parseFloat(paymentAmount) === 0) {
      setErrExists(true);
      setValidationMsg(`Enter payment amount`);
      return false;
    }
    if (parseFloat(paymentAmount) > parseFloat(sale_outstanding_amount)) {
      setErrExists(true);
      setValidationMsg(
        `The amount you are paying is more than the outstanding balance`,
      );
      return false;
    }

    if (
      checkMinimumPaymentAmount(
        sale_outstanding_amount,
        sale_total_amount,
        paymentAmount,
      )
    ) {
      setErrExists(true);
      setValidationMsg(
        `The payment amount must be at least 25% of the order total.`,
      );
      return false;
    }
    if (paymentAmount < 0) {
      setErrExists(true);
      setValidationMsg(`Amount needs to be bigger than 0`);
      return false;
    }
    return true;
  };
  const handleMakePaymentClick = () => {
    const isValid = handleValidation();
    if (isValid) {
      setIsLoading(true);
      axios
        .post(api.data.PAY_OUTSTANDING_AMOUNT, {
          amount: paymentAmount,
          sale_id,
        })
        .then((res) => {
          window.location.href = res.data.redirect_url;
        })
        .catch((err) => {
          setErrExists(true);
          setValidationMsg(err.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const makePaymentInputDiv = () => {
    return (
      <div className="u-text--right make-payment-container">
        <input
          className="make-payment-input"
          ref={inputAmountRef}
          name="amount"
          onChange={(e) => {
            e.preventDefault();
            setPaymentAmount(e.target.value);
          }}
          type="number"
          placeholder="R"
        />
      </div>
    );
  };

  const makePaymentButton = () => {
    return isLoading ? (
      <LuxityLoader />
    ) : (
      <GAButton
        className="btn--luxity make-payment-button"
        label="Make Payment"
        onClick={(e) => {
          e.preventDefault();
          handleMakePaymentClick();
        }}>
        PROCEED TO CREDIT CARD PAYMENT
      </GAButton>
    );
  };

  const errorMessageDiv = () => {
    return (
      <span className="payment-error-msg">
        {errExists ? validationMsg : null}
      </span>
    );
  };

  return (
    <Fragment>
      <div className="accordion-container payment-accordion">
        <div
          className={`payment-field-card${
            errExists ? ' payment-field-card--highlighted' : ''
          }`}>
          <div className="payment__error">{errorMessageDiv()}</div>
          <div className="payment-field-card__row payment-field-card__row--mobile-stack">
            <div className="payment-field-card__copy">
              <div className="payment-field-card__label">Pay Amount</div>
              <div className="payment-field-card__hint">
                Enter the amount you want to pay now.
              </div>
            </div>
            <div className="payment-field-card__input-wrap">
              {makePaymentInputDiv()}
            </div>
          </div>
          <div className="payment-field-card__cta">{makePaymentButton()}</div>
        </div>
      </div>
    </Fragment>
  );
}
